import { render, staticRenderFns } from "./AuthenticationMethodsDlg.vue?vue&type=template&id=1736c8f5&scoped=true"
import script from "./AuthenticationMethodsDlg.vue?vue&type=script&lang=ts"
export * from "./AuthenticationMethodsDlg.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationMethodsDlg.vue?vue&type=style&index=0&id=1736c8f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736c8f5",
  null
  
)

export default component.exports